import { GeoMetadata } from "@/lib/types";
import { GEO_INTENTS, GEO_USE_CASES, GEO_MODELS } from "@/data/geo-constants";
import { cn } from "@/lib/utils";

interface GeoBadgesProps {
  geoMetadata: GeoMetadata;
  compact?: boolean;
}

const intentIcons: Record<string, string> = {
  generate: "✨",
  analyze: "🔍",
  transform: "🔄",
  chat: "💬",
  code: "💻",
};

export function GeoBadges({ geoMetadata, compact = false }: GeoBadgesProps) {
  const intentLabel = GEO_INTENTS.find((i) => i.value === geoMetadata.intent)?.label;
  const useCaseLabel = GEO_USE_CASES.find((u) => u.value === geoMetadata.use_case)?.label;
  const modelLabel = geoMetadata.models?.recommended
    ? GEO_MODELS.find((m) => m.value === geoMetadata.models?.recommended)?.label
    : null;

  const intentIcon = intentIcons[geoMetadata.intent] || "🎯";

  if (compact) {
    return (
      <div className="flex items-center gap-1.5 flex-wrap">
        {intentLabel && (
          <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[10px] bg-brand-purple/10 text-brand-purple border border-brand-purple/20">
            {intentIcon} {intentLabel}
          </span>
        )}
        {useCaseLabel && (
          <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] bg-brand-cyan/10 text-brand-cyan border border-brand-cyan/20">
            {useCaseLabel}
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {intentLabel && (
        <span
          className={cn(
            "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs",
            "bg-brand-purple/10 text-brand-purple/80 border border-brand-purple/20"
          )}
        >
          {intentIcon} {intentLabel}
        </span>
      )}
      {useCaseLabel && (
        <span
          className={cn(
            "inline-flex items-center px-2 py-0.5 rounded-full text-xs",
            "bg-brand-cyan/10 text-brand-cyan/80 border border-brand-cyan/20"
          )}
        >
          {useCaseLabel}
        </span>
      )}
      {modelLabel && (
        <span
          className={cn(
            "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs",
            "bg-white/5 text-white/50 border border-white/10"
          )}
        >
          🤖 {modelLabel}
        </span>
      )}
    </div>
  );
}
